'use client';

import {servicesData} from './data';
import styles from './index.module.scss';
import Image from 'next/image'
import CustomSelect from "@/app/_components/Shared/CustomSelect";
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'

const selectData = servicesData.map(service => ({
    value: service.link,
    label: service.name,
}));

export const ServiceLayout = ({children}) => {
    const router = useRouter();
    const path = usePathname().replace(/\/$/, '');

    const onSelect = (selected) => {
        router.push(selected.value);
    };

    return (
        <div className={styles.container}>
            <div className="container-wrapper">
                <div className={styles.list}>
                    {servicesData.map((service, index) => (
                        <Link key={index} href={service.link} className={service.link === path ? styles.active : null}>
                            {service.icon && <Image src={service.icon} alt={service.name}/>}
                            {service.name}
                        </Link>
                    ))}
                </div>
                <div className={styles.content}>
                    <div className={styles.mobileSelect}>
                        <CustomSelect
                            onChange={onSelect}
                            value={selectData.find(option => option.value === path)}
                            options={selectData}
                            instanceId="serviceSelect"
                            isSearchable={false}
                        />
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}